import Image from "next/image";

import { useTranslations } from "next-intl";

import { Link, useRouter } from "@/i18n/routing";
import IconSquare from "@/icons/content/property/area.svg";
import { ConvertedPrices } from "@/types/pricing.types";
import { Button } from "@/ui/Button";
import { Amount, AmountVariant } from "@/ui/Common/Amount";
import { CustomSlider } from "@/ui/Common/CustomSlider";
import { cn } from "@/utils/cn";

import iconEmpty from "public/assets/img/empty.png";

import { IImagesProperty } from "@/types/images.types";
import ResponsiveImage from "../../ResponsiveImage";
import styles from "./style.module.scss";

interface Props {
  rooms: number;
  area: number[];
  convertedPrices?: ConvertedPrices;
  convertedPricesPerSqM?: ConvertedPrices;
  images: IImagesProperty[];
  type: string;
  slug: string;
}

export const CardLayouts = ({
  rooms,
  area,
  convertedPrices,
  convertedPricesPerSqM,
  images,
  slug,
}: Props) => {
  const t = useTranslations();
  const router = useRouter();

  console.log("images", images);

  const [minArea, maxArea] = area;

  const handleClick = () => {
    router.push(`/developers/${slug}/plans/?rooms[]=${rooms}`);
  };

  const renderArea = () => {
    if (minArea === maxArea) {
      return minArea;
    }

    return (
      <>
        {minArea} - {maxArea}
      </>
    );
  };

  return (
    <div className={styles.wrapper}>
      <CustomSlider
        className="!h-auto"
        main={
          <div className="flex">
            {images.length > 0 ? (
              images.map((image, index) => (
                <Link
                  className={styles.itemImages}
                  key={index}
                  href={`/developers/${slug}/plans/?rooms[]=${rooms}`}
                >
                  <ResponsiveImage
                    // sizes="(max-width: 768px) 640px"
                    maxSize="tablet"
                    style={{
                      width: "100%",
                      height: "27.5rem",
                      objectFit: "cover",
                    }}
                    images={image.populated}
                    alt={"appartment"}
                  />
                </Link>
              ))
            ) : (
              <Link
                className={styles.itemImages}
                href={`/developers/${slug}/plans/?rooms[]=${rooms}`}
              >
                <Image
                  width={0}
                  height={0}
                  sizes="(max-width: 768px) 640px"
                  style={{
                    width: "100%",
                    height: "27.5rem",
                    objectFit: "cover",
                  }}
                  src={iconEmpty}
                  alt={"is empty"}
                />
              </Link>
            )}
          </div>
        }
        length={images.length}
        isModal={true}
      />

      <Link
        href={`/developers/${slug}/plans/?rooms[]=${rooms}`}
        className={"px-8 py-8 block"}
      >
        <h3 className={"text-[1.8rem] xl:text-[2.1rem] font-bold mb-8"}>
          {rooms ? t("pluralization.room", { count: rooms }) : t("Plans")}
        </h3>

        <div className={"mb-[1.8rem]"}>
          <p className={"text-[1.8rem]"}>{t("Price")}</p>
          {convertedPrices ? (
            <>
              <p className={styles.titleBold}>
                {`${t("from")} `}
                <Amount
                  convertedPrices={convertedPricesPerSqM}
                  variant={AmountVariant.PER_SQUARE}
                />
              </p>
            </>
          ) : (
            <span>&mdash;</span>
          )}
        </div>
        <div className={cn(styles.container, styles.squareContainer)}>
          {minArea && maxArea && (
            <>
              <IconSquare className={"icon me-[1rem] text-gray-1000"} />
              <p>
                <span className={"text-[1.6rem] font-medium me-[1rem]"}>
                  {t("Square")}:
                </span>
                <span className={"text-[1.7rem] font-bold"}>
                  {renderArea()} {t("m2")}
                </span>
              </p>
            </>
          )}
        </div>
        <Button
          title={t("See more")}
          color="white"
          className="h-[5.4rem] w-full text-dark font-normal"
          onClick={handleClick}
        >
          <span className={styles.titleBtn}>{t("See more")}</span>
        </Button>
      </Link>
    </div>
  );
};
